module.exports = __webpack_public_path__ + "static/media/Daniel Rahman.17b14aa0.png";